import { FC, useState, useEffect, useMemo } from 'react'
import {
  ISectionTestLinkByMeaning,
  ISectionText,
  ISessionAnswer
} from 'shared/types'
import TestCard from 'shared/components/sections/tests/TestCard'
import TestTask from 'shared/components/sections/tests/TestTask'
import { getTestTitle } from 'shared/utils/tests'
import shuffle from 'lodash/shuffle'
import forEach from 'lodash/forEach'
import map from 'lodash/map'
import get from 'lodash/get'
import last from 'lodash/last'
import keyBy from 'lodash/keyBy'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import isNil from 'lodash/isNil'
import size from 'lodash/size'
import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import { VStack, HStack } from '@chakra-ui/react'
import MatchingElement, {
  IElementStatus
} from 'shared/components/sections/sectionTestLinkByMeaning/MatchingElement'
import CharInCircle from 'shared/components/sections/sectionTestLinkByMeaning/CharInCircle'
import Attempts from 'shared/components/sections/sectionTestLinkByMeaning/Attempts'

type Props = {
  s: ISectionTestLinkByMeaning
  onAnswer?: (sectionId: string, answer: ISessionAnswer) => void
  answer?: ISessionAnswer
  testNum?: number
  showUserAnswer?: boolean
  isExamination: boolean
  examinationStarted?: boolean
}

type ITask = {
  matchId1: string
  matchId2: string
  attempts: boolean[]
  word2ExamSelected?: string
}

const SectionTestLinkByMeaning: FC<Props> = ({
  s,
  onAnswer,
  answer: answerRaw,
  testNum,
  showUserAnswer,
  isExamination,
  examinationStarted
}) => {
  const [tasks, setTasks] = useState<ITask[]>([])
  const [selectedWordId, setSelectedWordId] = useState<string>()
  const [started, setStarted] = useState(false)

  const matchingDict = useMemo(() => {
    return keyBy(s.test?.matching, 'id')
  }, [s.test?.matching])

  // const highlightCorrectAnswer = get(s.test, 'highlightCorrectAnswer', false)

  useEffect(() => {
    if (tasks.length > 0 && started) {
      // let complete = true
      // let isCorrect = true

      // if (isExamination) {
      //   forEach(tasks, (t) => {
      //     if (t.word2ExamSelected !== t.matchId2) {
      //       complete = false
      //     }
      //   })
      // } else {
      //   forEach(tasks, (t) => {
      //     if (t.attempts.length < 3 && last(t.attempts) !== true) {
      //       complete = false
      //     }
      //     if (t.attempts.length === 3 && last(t.attempts) === false) {
      //       isCorrect = false
      //     }
      //   })
      // }
      // if (complete && onAnswer) {
      //   const sessionAnswer = {
      //     answer: '',
      //     isCorrect
      //   }
      //   onAnswer(s.id, sessionAnswer)
      // }

      let answersAmount = 0

      if (isExamination) {
        answersAmount = size(filter(tasks, (t) => !isNil(t.word2ExamSelected)))
      } else {
        answersAmount = size(
          filter(
            tasks,
            (t) => size(t.attempts) === 3 || last(t.attempts) === true
          )
        )
      }

      let correctAmount = 0
      if (isExamination) {
        correctAmount = size(
          filter(tasks, (t) => t.word2ExamSelected === t.matchId2)
        )
      } else {
        correctAmount = size(filter(tasks, (t) => last(t.attempts) === true))
      }

      const sa: ISessionAnswer = {
        isCorrect:
          tasks.length === answersAmount && answersAmount === correctAmount,
        answer: '',
        progress: {
          correctAmount,
          fullAmount: tasks.length,
          completed: tasks.length === answersAmount,
          answersAmount
        }
      }
      if (onAnswer) {
        console.log('sa', sa)
        onAnswer(s.id, sa)
      }
    }
  }, [tasks, isExamination, started])

  const answer =
    answerRaw && get(answerRaw.progress, 'completed', false)
      ? answerRaw
      : undefined

  useEffect(() => {
    if (s.test?.matching) {
      // create task
      const shuffledMatching = shuffle(s.test.matching)
      console.log('shuffledTask', shuffledMatching)

      let newTasks = []
      const matchingIds = shuffle(map(shuffledMatching, (m) => m.id))

      forEach(shuffledMatching, (m, i) => {
        const task: ITask = {
          matchId1: m.id,
          matchId2: matchingIds[i],
          attempts: []
        }

        newTasks.push(task)
      })

      setTasks(newTasks)
    }
  }, [s.test?.matching])

  const charByIndex = (i: number) => {
    return String.fromCharCode(i + 97)
  }

  const onWord1Click = (matchId: string) => {
    if (matchId === selectedWordId) {
      setSelectedWordId(undefined)
    } else {
      setSelectedWordId(matchId)
    }
  }

  console.log('render tasks', tasks)

  const onWord2Click = (matchId2: string) => {
    if (selectedWordId) {
      const newTasks = map(tasks, (t) => {
        if (t.matchId1 === selectedWordId) {
          if (t.attempts.length < 3 && last(t.attempts) !== true) {
            const newAttempts = [...t.attempts, matchId2 === selectedWordId]
            return {
              ...t,
              attempts: newAttempts
            }
          } else {
            return t
          }
        } else {
          return t
        }
      })
      setSelectedWordId(undefined)
      setTasks(newTasks)
      setStarted(true)
    }
  }

  const renderTaskRow = (t: ITask, i: number) => {
    let word1Status: IElementStatus = IElementStatus.DEFAULT
    let word1CanClick = true
    if (last(t.attempts) === true) {
      word1Status = IElementStatus.SUCCESS
      word1CanClick = false
    } else if (t.attempts.length === 3) {
      word1Status = IElementStatus.FAILED
      word1CanClick = false
    } else if (selectedWordId === t.matchId1) {
      word1Status = IElementStatus.SELECTED
    }

    let word2Status: IElementStatus = IElementStatus.DEFAULT
    let word2CanClick = !isNil(selectedWordId)
    const word2RelatedTaskIndex = findIndex(
      tasks,
      (rt: ITask) => rt.matchId1 === t.matchId2
    )
    const word2RelatedTask = tasks[word2RelatedTaskIndex]
    let word2Char = ''
    if (last(word2RelatedTask.attempts) === true) {
      word2Status = IElementStatus.SUCCESS
      word2CanClick = false
      word2Char = charByIndex(word2RelatedTaskIndex)
    } else if (word2RelatedTask.attempts.length === 3) {
      word2Status = IElementStatus.FAILED
      word2CanClick = false
      word2Char = charByIndex(word2RelatedTaskIndex)
    }
    return (
      <HStack w='full' spacing={{ lg: 8, base: 3 }} key={i}>
        <HStack w='full' spacing={1}>
          <CharInCircle ch={charByIndex(i)} status={word1Status} />
          <MatchingElement
            text={get(matchingDict, [t.matchId1, 'word1'])}
            status={word1Status}
            onClick={word1CanClick ? () => onWord1Click(t.matchId1) : undefined}
          />
          <Attempts attempts={t.attempts} />
        </HStack>

        <HStack w='full'>
          <MatchingElement
            text={get(matchingDict, [t.matchId2, 'word2'])}
            status={word2Status}
            onClick={word2CanClick ? () => onWord2Click(t.matchId2) : undefined}
          />
          <CharInCircle ch={word2Char} status={word2Status} />
        </HStack>
      </HStack>
    )
  }

  const onWordExam2Click = (matchId2: string) => {
    if (selectedWordId) {
      const newTasks = tasks.map((t: ITask) => {
        if (t.matchId2 === matchId2) {
          return { ...t, word2ExamSelected: selectedWordId }
        } else if (t.word2ExamSelected === selectedWordId) {
          return { ...t, word2ExamSelected: undefined }
        } else {
          return t
        }
      })
      setSelectedWordId(undefined)
      setTasks(newTasks)
      setStarted(true)
    } else {
      const newTasks = tasks.map((t: ITask) => {
        if (t.matchId2 === matchId2) {
          return { ...t, word2ExamSelected: undefined }
        } else {
          return t
        }
      })
      setSelectedWordId(undefined)
      setTasks(newTasks)
      setStarted(true)
    }
  }

  const renderExaminationTaskRow = (t: ITask, i: number) => {
    let word1Status: IElementStatus = IElementStatus.DEFAULT
    const readOnly = !showUserAnswer
    const word1Matched =
      findIndex(tasks, (task) => task.word2ExamSelected === t.matchId1) !== -1
    if (readOnly) {
      const relatedAnswer = find(tasks, (task) => task.matchId2 === t.matchId1)
      if (relatedAnswer.word2ExamSelected === relatedAnswer.matchId2) {
        word1Status = IElementStatus.SUCCESS
      } else {
        word1Status = IElementStatus.FAILED
      }
    } else if (t.matchId1 === selectedWordId || word1Matched) {
      word1Status = IElementStatus.SELECTED
    }

    const word2Char = t.word2ExamSelected
      ? charByIndex(
          findIndex(tasks, (task) => task.matchId1 === t.word2ExamSelected)
        )
      : ''

    let word2Status = t.word2ExamSelected
      ? IElementStatus.SELECTED
      : IElementStatus.DEFAULT
    if (readOnly) {
      if (t.word2ExamSelected === t.matchId2) {
        word2Status = IElementStatus.SUCCESS
      } else {
        word2Status = IElementStatus.FAILED
      }
    }
    return (
      <HStack w='full' spacing={{ lg: 8, base: 3 }} key={i}>
        <HStack w='full' spacing={1}>
          <CharInCircle ch={charByIndex(i)} status={word1Status} />
          <MatchingElement
            text={get(matchingDict, [t.matchId1, 'word1'])}
            status={word1Status}
            onClick={readOnly ? undefined : () => onWord1Click(t.matchId1)}
          />
        </HStack>

        <HStack w='full'>
          <MatchingElement
            text={get(matchingDict, [t.matchId2, 'word2'])}
            status={word2Status}
            onClick={readOnly ? undefined : () => onWordExam2Click(t.matchId2)}
          />
          <CharInCircle ch={word2Char} status={word2Status} />
        </HStack>
      </HStack>
    )
  }

  const renderQuestion = () => {
    return (
      <VStack w='full' spacing={4}>
        {map(tasks, isExamination ? renderExaminationTaskRow : renderTaskRow)}
      </VStack>
    )
  }

  return (
    <TestCard showUserAnswer={showUserAnswer} answer={answer}>
      <TestTask
        title={s.test?.title || getTestTitle(s.type)}
        answer={showUserAnswer ? undefined : answer}
        testNum={testNum}
      />
      {renderQuestion()}
    </TestCard>
  )
}

export default SectionTestLinkByMeaning
